var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcEyeBlack20 = function SvgIcEyeBlack20(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M17.95 9.733C17.816 9.467 15.01 4 10 4S2.184 9.467 2.05 9.733a.92.92 0 0 0 0 .6C2.184 10.533 4.99 16 10 16s7.816-5.467 7.95-5.733a.735.735 0 0 0 0-.534zM10 14.667c-3.608 0-5.946-3.6-6.614-4.667C3.987 8.933 6.392 5.333 10 5.333s5.946 3.6 6.614 4.667c-.668 1.067-3.006 4.667-6.614 4.667zm0-7.334c-1.47 0-2.672 1.2-2.672 2.667A2.677 2.677 0 0 0 10 12.667c1.47 0 2.672-1.2 2.672-2.667A2.677 2.677 0 0 0 10 7.333zm0 4c-.735 0-1.336-.6-1.336-1.333S9.265 8.667 10 8.667c.735 0 1.336.6 1.336 1.333s-.601 1.333-1.336 1.333z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#757575",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcEyeBlack20);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-eye-black-20.8462ac1fe167ade09cef276a1076dd5a.svg";